import { AfterViewInit, Component, Input, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs";
import { EnvironmentLogComponent, FileTransferLogComponent, RemotePlatformLogComponent } from "..";
import {
    IOcbLocalAgentCommand,
    OcbLocalAgentCommand,
    OcbLocalAgentCommandStatus,
    OcbLocalAgentCommandTarget
} from "../../core";

@Component({
    selector: 'app-local-agent-command',
    templateUrl: './local-agent-command-popup.component.html',
    styleUrls: ['./local-agent-command-popup.component.scss']
})
export class LocalAgentCommandComponent implements AfterViewInit {
    @Input() public agentCommand?: IOcbLocalAgentCommand;

    public visible: boolean = false;

    @ViewChild('environmentLogPopup')
    environmentLogPopup: EnvironmentLogComponent;
    @ViewChild('fileTransferLogPopup')
    fileTransferLogPopup: FileTransferLogComponent;
    @ViewChild('remotePlatformLogPopup')
    remotePlatformLogPopup: RemotePlatformLogComponent;

    private commandsLabels: any;
    private commandsStatusLabels: any;
    private commandsTargetsLabels: any;

    constructor(private translateService: TranslateService) {
        this.displayCommand = this.displayCommand.bind(this);
        this.displayStatus = this.displayStatus.bind(this);
        this.displayTarget = this.displayTarget.bind(this);
        this.displayName = this.displayName.bind(this);
    }

    public ngAfterViewInit() {
        forkJoin([
            this.translateService.get('localAgentsCommandsLabels'),
            this.translateService.get('localAgentsCommandsStatus'),
            this.translateService.get('localAgentsCommandsTargets')
        ]).subscribe({
            next: (labels) => {
                this.commandsLabels = labels[0];
                this.commandsStatusLabels = labels[1];
                this.commandsTargetsLabels = labels[2];
            }
        });
    }

    public displayCommand(agentCommand) { return this.commandsLabels[OcbLocalAgentCommand[agentCommand.command]]; }
    public displayStatus(agentCommand) { return this.commandsStatusLabels[OcbLocalAgentCommandStatus[agentCommand.status]]; }
    public displayTarget(agentCommand): string { return this.commandsTargetsLabels[OcbLocalAgentCommandTarget[agentCommand.target]]; }
    public displayName(agentCommand): string { return agentCommand.requestedByUser ? agentCommand.requestedByUser.displayName : ''; }
    

    public openEnvironmentLog(id) {
        this.environmentLogPopup.logId = id;
        this.environmentLogPopup.visible = true;
    }
    public openFileTransferLog(id) {
        this.fileTransferLogPopup.logId = id;
        this.fileTransferLogPopup.visible = true;
    }
    public openRemotePlatformLog(id) {
        this.remotePlatformLogPopup.logId = id;
        this.remotePlatformLogPopup.visible = true;
    }
    
}